import type { CanBuilder } from "../types";

export function defineSpecialistRules(can: CanBuilder): void {
	can("create", "Principle");
	can("update", "Principle");
	can("delete", "Principle");

	can("create", "Section");
	can("update", "Section");
	can("delete", "Section");

	can("create", "Question");
	can("update", "Question");
	can("delete", "Question");

	can("create", "Glossary");
	can("update", "Glossary");
	can("delete", "Glossary");
}
